import playbackVod from './playbackVod';
import playbackEpg from './playbackEpg';

export default function experience(backendAxiosInstance) {
  return {
    ...playbackVod(backendAxiosInstance),
    ...playbackEpg(backendAxiosInstance),
  };
}
